export const INFO = "INFO";
export const WARNING = "WARNING";
export const ERROR = "ERROR";
